<template>
    <el-table stripe v-loading="loading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
        :header-cell-style="headCellStyle" :cell-style="bodyCellStyle" :height="tableHeight"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="sceneName" :label="$t('public.table_scope')" v-if="isSysAdmin" show-overflow-tooltip />
        <el-table-column :label="$t('syslog.func_module')" show-overflow-tooltip prop="module">
            <template #default={row}>
                {{ $t('modules.'+row.module)}}
            </template>
        </el-table-column>
        <el-table-column :label="$t('syslog.content')" show-overflow-tooltip prop="action">
            <template #default={row}>
                {{$t('func.'+row.action)}}
            </template>
        </el-table-column>
        <el-table-column :label="$t('URL')" show-overflow-tooltip prop="url" />
        <el-table-column :label="$t('syslog.operator')" show-overflow-tooltip prop="operator" width="120px" />
        <el-table-column :label="$t('syslog.operation_time')" show-overflow-tooltip prop="recordTime">
            <template #default="{ row }">{{ $timetransition(row.recordTime) }}</template>
        </el-table-column>
        <el-table-column :label="$t('syslog.operation')" show-overflow-tooltip prop="operate" width="120px">
            <template #default="{ row }">
                <div class="uk-flex uk-flex-center">
                    <el-button type="text" icon="el-icon-tickets" size="small" :title="$t('public.tbopt_detail')"
                        v-has="['uptRange']" @click="detailFn(row)"></el-button>
                    <el-button @click="delsMonitor(row)" :title="$t('public.tbopt_delete')" icon="el-icon-delete"
                        type="text" size="small" v-has="['delRange']"></el-button>
                </div>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
export default {
    computed: {
        isSysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            return (currentUser.sysScope && currentUser.sysAdmin) || (currentUser.sysScope && !currentUser.sysAdmin);
        }
    },
    props: ['loading', 'tableData'],
    data() {
        return {
            tableHeight: 'calc(100% - 60px)'
        };
    },
    methods: {
        handleSelectionChange(arg) {
            this.$emit('choozeTableFn', arg);
        },
        detailFn(row) {
            this.$emit('detailRow', row);
        },
        delsMonitor(row) {
            this.$emit('delRow', row);
        }
    }
};
</script>

<style></style>
